/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Backend_Prod_TitleInputs */

const en_mobile_dev_backend_prod_title = /** @type {(inputs: Mobile_Dev_Backend_Prod_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to production?`)
};

const es_mobile_dev_backend_prod_title = /** @type {(inputs: Mobile_Dev_Backend_Prod_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cambiar a producción?`)
};

/**
* | output |
* | --- |
* | "Switch to production?" |
*
* @param {Mobile_Dev_Backend_Prod_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_backend_prod_title = /** @type {((inputs?: Mobile_Dev_Backend_Prod_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Backend_Prod_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_backend_prod_title(inputs)
	return en_mobile_dev_backend_prod_title(inputs)
});